import { gql } from '@apollo/client';


  // export const listAgendaPosts = gql/* GraphQL */ `
  // query ListAgendaPosts(
  //   $filter: ModelAgendaPostFilterInput
  //   $limit: Int
  //   $nextToken: String
  //   $postId: ID
  //   $sortDirection: ModelSortDirection
  // ) {
  //   listAgendaPosts(
  //     filter: $filter
  //     limit: $limit
  //     nextToken: $nextToken
  //     postId: $postId
  //     sortDirection: $sortDirection
  //   ) {
  //     items {
  //       comId
  //       createdAt
  //       deleted
  //       description
  //       image
  //       postId
  //       updatedAt
  //       userId
  //       username
  //       __typename
  //     }
  //     nextToken
  //     __typename
  //   }
  // }
  // `

  export const postsByCompany = gql/* GraphQL */ `
  query PostsByCompany(
    $comId: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelAgendaPostFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    postsByCompany(
      comId: $comId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        comId
        createdAt
        deleted
        description
        postId
        updatedAt
        userId
        room
        image
        username
        __typename
        user {
          username
          image
        }
      }
      nextToken
      __typename
    }
  }
  `;

  export const postByRoom = gql/* GraphQL */ `
  query PostByRoom(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelAgendaPostFilterInput
    $limit: Int
    $nextToken: String
    $room: String!
    $sortDirection: ModelSortDirection
  ) {
    postByRoom(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      room: $room
      sortDirection: $sortDirection
    ) {
      items {
        comId
        createdAt
        deleted
        description
        image
        postId
        room
        updatedAt
        userId
        username
        __typename
      }
      nextToken
      __typename
    }
  }
  `;
  
export const getAgendaUser = gql /* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      image
      isConfirmed
      role
      suspended
      type
      hours
      language
      timezone
      userId
      username
      FCMtoken
      readedAt
      __typename
    }
  }
  `;

// export const onCreateAgendaPost = gql/* GraphQL */ `
// subscription OnCreateAgendaPost(
//   $filter: ModelSubscriptionAgendaPostFilterInput
// ) {
//   onCreateAgendaPost(filter: $filter) {
//     com {
//       comId
//       createdAt
//       name
//       suspended
//       tags
//       updatedAt
//       __typename
//     }
//     comId
//     createdAt
//     deleted
//     description
//     image
//     postId
//     postNotif {
//       nextToken
//       __typename
//     }
//     updatedAt
//     user {
//       comId
//       image
//       readedAt
//       role
//       suspended
//       type
//       username
//       __typename
//     }
//     userId
//     __typename
//   }
// }
// `;

// export const onCreateAgendaPostByCompanyId = gql/* GraphQL */ `
// subscription OnCreateAgendaPostByCompanyId {
//   onCreateAgendaPostByCompanyId {
//     com {
//       comId
//       createdAt
//       name
//       suspended
//       tags
//       updatedAt
//       __typename
//     }
//     comId
//     createdAt
//     deleted
//     description
//     image
//     username
//     postId
//     postNotif {
//       nextToken
//       __typename
//     }
//     updatedAt
//     user {
//       comId
//       createdAt
//       email
//       firstName
//       image
//       isConfirmed
//       language
//       lastName
//       password
//       phoneNumber
//       profileOwner
//       readedAt
//       role
//       suspended
//       type
//       updatedAt
//       userId
//       username
//       __typename
//     }
//     userId
//     __typename
//   }
// }
// `;

export const onCreateAgendaPostByCompanyId = gql/* GraphQL */ `
subscription OnCreateAgendaPostByCompanyId {
  onCreateAgendaPostByCompanyId {
    comId
    createdAt
    deleted
    description
    room
    image
    postId
    updatedAt
    user {
      comId
      image
      username
      __typename
    }
    userId
    username
    __typename
  }
}
`;